import client from './http';

const createAccount = query => client.get(`accounts${query}`);
export default createAccount;




// WEBPACK FOOTER //
// ./src/services/accounts.js